import { POSATypeJavascriptDTO } from "@tootsweet/model/lottery/POSAType";
import Axios from "axios";
import CONFIG from "../../../model/TSConfig";
import { STORAGE_TOKEN_KEY } from "../../../utils/constants";
import {
  type POSAPricesJavaDTO,
  type POSAPricesJavascriptDTO
} from "@tootsweet/model/lottery/POSAPrices";
import { type Config } from "kadow-jetpack-model";
import { type EventConfig } from "kadow-jetpack-model";
import { CustomPOSA_Javascript_DTO } from "@tootsweet/model/entities/saas/CustomPOSA";
import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import PrizeTemplateDTO from "../../../model/PrizeTemplateDTO";

export default class OnboardingAPI {
  static async getEvents(): Promise<EventConfig[]> {
    const res = await Axios({
      method: "GET",
      url: `${CONFIG.saasBackendUrl}/events/all`
    });

    if (!res.data) {
      return [];
    }

    return res.data.sort((a: EventConfig, b: EventConfig) => {
      return a.name.localeCompare(b._id);
    });
  }

  static async getEventById(eventId: string): Promise<EventConfig | null> {
    try {
      const res = await Axios({
        method: "GET",
        url: `${CONFIG.saasBackendUrl}/events/${eventId}`
      });
      return res.data || null;
    } catch (error) {
      console.error(`Failed to fetch event with ID ${eventId}:`, error);
      return null;
    }
  }

  static async getAllCustomPOSA(
    trackingID: string,
    token: string
  ): Promise<CustomPOSA_Javascript_DTO> {
    const res = await Axios({
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      url: `${CONFIG.saasBackendUrl}/posa/custom`,
      params: {
        trackingID
      }
    });
    return res.data;
  }

  static async getAllPOSATypes(): Promise<POSATypeJavascriptDTO[]> {
    const res = await Axios({
      method: "GET",
      url: `${CONFIG.saasBackendUrl}/posa/type`
    });
    return res.data;
  }

  static async getAllPOSAPricesWithMarkup(): Promise<
    POSAPricesJavascriptDTO[]
  > {
    const token = localStorage.getItem(STORAGE_TOKEN_KEY);
    const res = await Axios({
      method: "GET",
      url: CONFIG.saasBackendUrl + `/posa/prices`,
      headers: { Authorization: `Bearer ${token}` }
    });
    /**
     * Temporary fix
     */
    if (res.data.code || !res.data) {
      return [];
    } else {
      res.data?.forEach((d: POSAPricesJavascriptDTO & POSAPricesJavaDTO) => {
        if (d.id) {
          d.id === d._id;
        }
      });
      return res.data;
    }
  }

  static async getJetpackDraftConfig(
    accountToDisplay: ManagedAccount
  ): Promise<Config> {
    const res = await Axios({
      method: "GET",
      url: `${CONFIG.saasBackendUrl}/jetpack-config/${accountToDisplay.trackingID}`,
      headers: { Authorization: `Bearer ${accountToDisplay.token}` }
    });
    return res.data;
  }

  static async getJetpackPrizeTemplates(
    accountToDisplay: ManagedAccount
  ): Promise<PrizeTemplateDTO[]> {
    const res = await Axios({
      method: "GET",
      url: `${CONFIG.saasBackendUrl}/jetpack-config/prize-templates`,
      headers: { Authorization: `Bearer ${accountToDisplay.token}` },
      params: {
        sector: accountToDisplay.businessUser?.customerType,
        locale: accountToDisplay.businessUser?.locale
      }
    });

    return res.data;
  }

  static async updateJetpackDraftConfig(
    id: string,
    token: string,
    update: Partial<Config>
  ): Promise<Config> {
    const res = await Axios.put(
      `${CONFIG.saasBackendUrl}/jetpack-config/update/draft/${id}`,
      update,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    return res.data;
  }
}
